Ext.define('SA.view.sidebar.data.DatasetAttributeList', {
    alias: 'widget.dataset-attribute-list',
    extend: 'SA.view.SimpleContainer',

    initComponent() {
        this.items = [
            {
                xtype: 'component',
                cls: 'sa-dataset-attribute-list-dataset-path',
                html: `My Imported Data » ${Ext.String.htmlEncode(this.name)}`
            }, {
                xtype: 'simple-container',
                itemId: 'attributeList',
                items: this.attributes
            }
        ];

        this.callParent();
    },

    getAttributes() {
        return this.down('#attributeList').getChildItems();
    },

    getFilteredCount() {
        return this.getAttributes().filter(attribute => attribute.isVisible()).length;
    },

    setFilter(filter) {
        this.getAttributes().forEach(attribute => attribute.setFilter(filter));

        this.setVisible(this.getFilteredCount());
    }
});